import myHeader from "../../components/header.vue";
import myFooter from "../../components/footer.vue";
import SwiperCard from "../../components/swiper_card.vue";
import CateBox from "../../components/CateBox";
import Home_v2 from "../../components/Home3.0/";
import {
  getToken
} from '@/utilsCloud/auth'
import {
  getEntpOtherConfig
} from "../../apiCloud/common";
import {
  mapGetters
} from "vuex";
export default {
  components: {
    myHeader,
    myFooter,
    CateBox,
    ...Home_v2
  },
  data() {
    return {
      isShowCode: false,
      visitorMode: 0,
    }
  },
  computed: {
    ...mapGetters(["studyQrCode","websiteInfo","entpType"])
  },
  created() {
    this.getLessonConfiguration()
  },
  methods: {
    //获取当前培训机构其他配置信息
    getLessonConfiguration() {
      let data = {}
      getEntpOtherConfig(data).then((res) => {
        this.visitorMode = res.data.visitorMode
        if (res.data.visitorMode == 1) {
          if (!getToken()) {
            this.$router.push({
              path: "/login"
            })
          }
        }
        if (res.data.showQrCode == 0) {
          this.isShowCode = true
        } else {
          this.isShowCode = false
        }
      });
    },
    closeFloat() {
      this.isShowCode = false
    },
    //swiper点击,事件
    handClickSlide(index) {
      this.$emit("itemClick", "item");
      let id = this.personalCourseCateList[index].courseId
      let packagebagIdA = this.personalCourseCateList[index].packagebagId ?
        this.personalCourseCateList[index].packagebagId : ''
      let type = '私有课程'
      this.$router.push({
        // path:"/courseDetail",
        name: 'courseDetail',
        params: {
          courseId: id,
          packagebagId: packagebagIdA,
          oldPage: 1,
          courseType: type
        }
      });
      localStorage.setItem("packagebagId", this.personalCourseCateList[index].packagebagId)
      localStorage.setItem("courseId", id);
      localStorage.setItem("courseType", type)
    },


  },
};



// WEBPACK FOOTER //
// ./src/pages/home/realHome.js